import type { LensCardData } from '~/types/leLens';

import type { LensCardViewProps } from './cards/LensCardView';

export function cardComparison(data: LensCardData | undefined): LensCardViewProps['comparison'] {
  if (!data?.comparison || data.period?.comparable === false) {
    return undefined;
  }
  return {
    data: { cardId: data.cardId, ...data.comparison },
    period: data.period,
    isFetching: false,
    label: data.period?.label.comparison ?? 'Comparison',
  };
}
